
import { defineComponent } from 'vue';
export default defineComponent({
  data() {
    return {
      icons: [
        'skin',
        'hair',
        'eyes',
        'nose-mouth',
        'blush',
        'background',
        'clothes'
      ],
      selectedTab: 'skin'
    };
  },
  watch: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    $route(to, _from) {
      if (this.selectedTab !== to.name) {
        this.onSelectTab(to.name);
      }
    }
  },
  methods: {
    iconPath(icon: string): string {
      return require('@/assets/icons.svg') + '#' + icon;
    },
    onSelectTab(icon: string): void {
      this.selectedTab = icon;
    }
  }
});
